import request from "@/utils/request";
import config from "@/config";
import { getToken } from "@/utils/auth"; // get token
let serveUrl = config.baseUrl;

let personalCenterBaseUrl = config.personalCenterBaseUrl;

let adminCenterUrl = config.adminCenterUrl;
let token = '';

export function getMailSuffix(data) {
  token = getToken();
  return request({
    url: `https://portal-service.xisu.edu.cn/portalCenter/v1/thrid-adapter/getMailSuffix`, //获取邮箱后缀 https://portal-service.xisu.edu.cn
    method: "get",
		headerType: 'xisu',
    token: token
  });
}

export function checkEmailBoxIsExist(data) {
  token = getToken();
  return request({
    url: `https://portal-service.xisu.edu.cn/portalCenter/v1/thrid-adapter/checkEmailBoxIsExist`, //检测邮箱是否已注册
    method: "get",
		headerType: 'xisu',
    params: data,
    token: token
  });
}

export function sendCode(data) {
  token = getToken();
  return request({
    url: `https://portal-service.xisu.edu.cn/portalCenter/v1/thrid-adapter/sendCode`, //发送验证码
    method: "get",
		headerType: 'xisu',
		params: data,
    token: token
  });
}

export function registerEmailBox(email) {
  token = getToken();
  return request({
    url: `https://portal-service.xisu.edu.cn/portalCenter/v1/thrid-adapter/registerEmailBox`, //注册邮箱
    method: "POST",
		headerType: 'xisu',
		data: email,
    token: token
  });
}

export function saveEmailBox(email) {
  token = getToken();
  return request({
    url: `https://portal-service.xisu.edu.cn/portalCenter/v1/thrid-adapter/saveEmailBox`, //绑定邮箱
    method: "POST",
		headerType: 'xisu',
		data: email,
    token: token
  });
}